(() => {
  const SINGLE = 67978387161303;
  const BOX = 67978817306839;
  const LIMIT = 3000000;
  const MARK = '_bjapi_creatina_regalo';
  const CODE = 'REGALO-CREATINA';
  const isGift = (item) => item.properties?.[MARK] === 'v1';
  const desiredGift = (cart) => {
    const paid = cart.items.filter((item) => !isGift(item) && item.final_line_price > 0);
    const subtotal = paid.reduce((sum, item) => sum + item.final_line_price, 0);
    return subtotal > 0 ? (subtotal >= LIMIT ? BOX : SINGLE) : null;
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = { desiredGift, isGift, SINGLE, BOX };
  if (typeof window === 'undefined') return;
  if (window.__bjCreatinaGift) return;
  window.__bjCreatinaGift = true;
  const nativeFetch = window.fetch.bind(window);
  const root = window.Shopify?.routes?.root || '/';
  let queue = Promise.resolve();
  let bypass = false;
  let lastError = '';
  const api = async (path, payload) => {
    const response = await nativeFetch(root + path, payload === undefined
      ? { credentials: 'same-origin', cache: 'no-store' }
      : { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
    if (!response.ok) throw new Error('No se pudo actualizar el regalo de creatina.');
    return response.json();
  };
  const codes = (cart) => [...new Set((cart.discount_codes || []).map((discount) => discount.code).filter(Boolean))];
  const withoutGiftCode = (cart) => codes(cart).filter((code) => code.toUpperCase() !== CODE);
  const note = (message = '') => {
    lastError = message;
    let box = document.getElementById('bj-creatina-gift-status');
    if (!box) {
      box = document.createElement('p');
      box.id = 'bj-creatina-gift-status';
      box.setAttribute('role', 'status');
      box.style.cssText = 'position:fixed;bottom:70px;left:16px;right:16px;z-index:1000;margin:0;padding:12px;background:#fff;color:#8b1a1a;border:1px solid currentColor;font:15px Arial';
      document.body.append(box);
    }
    box.textContent = message;
    box.hidden = !message;
  };
  const removeGifts = async (cart) => {
    const updates = Object.fromEntries(cart.items.filter(isGift).map((item) => [item.key, 0]));
    return Object.keys(updates).length ? api('cart/update.js', { updates }) : cart;
  };
  const settle = async () => {
    let cart = await api('cart.js');
    let changed = false;
    const desired = desiredGift(cart);
    const gifts = cart.items.filter(isGift);
    if (gifts.length !== (desired ? 1 : 0) || gifts.some((gift) => gift.variant_id !== desired || gift.quantity !== 1)) {
      cart = await removeGifts(cart);
      changed = gifts.length > 0;
      if (desired) {
        await api('cart/add.js', { items: [{ id: desired, quantity: 1, properties: { [MARK]: 'v1', Regalo: desired === BOX ? 'Caja de 4 barritas de creatina' : '1 barrita de creatina' } }] });
        cart = await api('cart.js');
        changed = true;
      }
    }
    const hasCode = codes(cart).some((code) => code.toUpperCase() === CODE);
    if (desired === BOX && !hasCode) {
      cart = await api('cart/update.js', { discount: [...withoutGiftCode(cart), CODE].join(',') });
      changed = true;
    } else if (desired !== BOX && hasCode) {
      cart = await api('cart/update.js', { discount: withoutGiftCode(cart).join(',') });
      changed = true;
    }
    const chargedGift = cart.items.find((item) => isGift(item) && item.final_line_price > 0);
    if (chargedGift) {
      cart = await removeGifts(cart);
      changed = true;
      note('El regalo no pudo quedar gratis con los descuentos actuales. No lo agregamos para evitar cobrarlo.');
    } else {
      note();
    }
    return { cart, changed };
  };
  const sectionsFor = async (ids) => {
    const url = new URL(location.href);
    url.searchParams.set('sections', ids.join(','));
    return (await nativeFetch(url, { credentials: 'same-origin', cache: 'no-store' })).json();
  };
  const refresh = async (cart) => {
    const current = document.getElementById('shopify-section-cart-drawer-section');
    if (current) {
      const wasOpen = Boolean(current.querySelector('dialog[open]'));
      const sections = await sectionsFor(['cart-drawer-section']);
      const parsed = new DOMParser().parseFromString(sections['cart-drawer-section'] || '', 'text/html');
      const next = parsed.getElementById('shopify-section-cart-drawer-section');
      if (next) current.innerHTML = next.innerHTML;
      if (wasOpen) current.querySelector('#cart-drawer')?.open?.();
    }
    document.querySelector('cart-icon')?.renderCartBubble?.(cart.item_count);
  };
  const enqueue = (job) => {
    const result = queue.then(job, job);
    queue = result.catch(() => {});
    return result;
  };
  window.fetch = function (input, options) {
    const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
    const method = (options?.method || (input instanceof Request ? input.method : 'GET')).toUpperCase();
    if (url.origin !== location.origin || method !== 'POST' || !/\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname)) return nativeFetch(input, options);
    return enqueue(async () => {
      const response = await nativeFetch(input, options);
      if (!response.ok) return response;
      try {
        const original = await response.clone().json();
        const { cart, changed } = await settle();
        if (!changed) return response;
        if (original.sections) {
          const sections = await sectionsFor(Object.keys(original.sections));
          const body = /\/cart\/add/.test(url.pathname) ? { ...original, sections } : { ...cart, sections };
          return new Response(JSON.stringify(body), { status: response.status, headers: { 'Content-Type': 'application/json' } });
        }
        await refresh(cart);
      } catch (error) {
        note('No pudimos actualizar tu regalo. Revisa el carrito antes de pagar.');
        console.warn('[B-Japi regalo creatina]', error);
      }
      return response;
    });
  };
  const reconcile = () => enqueue(async () => {
    try {
      const { cart, changed } = await settle();
      if (changed) await refresh(cart);
      return cart;
    } catch (error) {
      note('No pudimos actualizar tu regalo. Inténtalo nuevamente antes de pagar.');
      throw error;
    }
  });
  document.addEventListener('click', (event) => {
    const target = event.target.closest('button[name="checkout"],input[name="checkout"],a[href*="/checkout"]');
    if (!target || bypass) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    reconcile().then((cart) => {
      if (cart.items.some((item) => isGift(item) && item.final_line_price > 0)) return;
      if (lastError) return;
      bypass = true;
      // Rendering fresh cart sections can replace the original checkout button.
      const checkout = target.isConnected ? target : document.querySelector('button[name="checkout"],input[name="checkout"],a[href*="/checkout"]');
      checkout?.click();
      setTimeout(() => { bypass = false; }, 0);
    }).catch(() => {});
  }, true);
  window.addEventListener('pageshow', () => reconcile().catch(() => {}));
  document.addEventListener('visibilitychange', () => { if (!document.hidden) reconcile().catch(() => {}); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => reconcile().catch(() => {}), { once: true });
  else reconcile().catch(() => {});
})();

